import styled from 'styled-components';

interface ICarouselWrapperStyledProps {
    dotsLeftOffset?: number;
    centerDots?: boolean;
}

export const CarouselWrapperStyled = styled.div<ICarouselWrapperStyledProps>`
    .carousel .control-dots {
        width: unset;
        ${({ dotsLeftOffset }) => dotsLeftOffset && 'margin-left: ' + dotsLeftOffset + ';'};
        ${({ centerDots }) => centerDots && 'width: 100%; margin-left: 0;'};
        margin-bottom: 5px;

        .dot {
            box-shadow: none;
            opacity: 1;
            background: var(--color-purple-highlight);
            margin: 0 12px;
            width: 14px;
            height: 14px;

            &.selected {
                background: var(--color-yellow);
            }

            &:hover:not(.selected) {
                background: var(--color-white);
            }
        }
    }
`;
